import { render, staticRenderFns } from "./_DashboardView.vue?vue&type=template&id=6032bc90&"
import script from "./_DashboardView.vue?vue&type=script&lang=js&"
export * from "./_DashboardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports